import React from "react";
import { Link } from "react-router-dom";
import { Moon, ArrowLeft } from "lucide-react";
import StarField from "../components/StarField";

const NotFoundPage = () => {
  return (
    <div className="relative min-h-[80vh] flex items-center" data-testid="notfound-page">
      <StarField count={60} />
      <div className="container-lux relative text-center max-w-2xl mx-auto">
        <Moon className="w-16 h-16 text-gold mx-auto mb-6 moon-glow float-gentle" />
        <div className="font-serif text-[8rem] md:text-[12rem] text-gold leading-none tracking-tighter">404</div>
        <h1 className="font-serif text-3xl md:text-4xl mt-4 mb-4">Lost among the stars.</h1>
        <p className="text-white/70 mb-10">The page you're looking for seems to have drifted into another orbit.</p>
        <Link
          to="/"
          className="btn-gold inline-flex items-center gap-2 rounded-full bg-gold px-8 py-4 text-sm font-semibold tracking-[0.12em] uppercase text-deep hover:bg-gold-light transition-all"
          data-testid="notfound-home-btn"
        >
          <ArrowLeft className="w-4 h-4" /> Back Home
        </Link>
      </div>
    </div>
  );
};

export default NotFoundPage;
